import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Drawer,
  ListItem,
  ListItemText,
  MenuList,
  useMediaQuery,
  List,
  IconButton,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { pageListAdmin } from "../utils/pageList";
import Logo from "../img/Logo.png";
import HomeIcon from "@mui/icons-material/Home";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ListItemButton from "@mui/material/ListItemButton";
import MenuIcon from "@mui/icons-material/Menu";
import SbSettingIcon from "../img/Settings.png";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SideBar(props) {
  const [t, i18n] = useTranslation("global");
  const [userRole, setUserRole] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserRole"))
  );
  const [boqTeam, setBoqTeam] = React.useState("");

  // Verify user role for access page
  useEffect(() => {
    if (userRole && userRole.role !== "admin") {
      // If not admin, set active tab from user role
      const team = userRole.role;
      if (team.length > 0) {
        // Remove suffix role _user or _admin
        const team = userRole.role.replace(/_(user|admin)$/i, "");
        // Replace _ to - for URL
        const teamFormatted = team.replace(/_/g, "-");
        setBoqTeam(teamFormatted);
      } else {
        // If no team assigned, redirect to unauthorized page
        window.location.href = "/unauthorized";
      }
    } else {
      setBoqTeam("lbd");
    }
  }, [userRole]);

  const styles = {
    sideBarIcon: {
      width: 32,
      height: 32,
    },
  };
  const location = useLocation();
  // Access URL components
  const pathname = location.pathname; // Get the pathname (path after the domain)
  const isHome = pathname.split("/")[1] == "home" ? true : false; // Remove "/"

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
    onClose(newOpen);
  };

  const [openGroup, setOpenGroup] = React.useState(pageListAdmin);

  const handleClick = (title, status, index) => {
    const clickValue = openGroup.map((group) => {
      return group.title === title
        ? { ...group, status: !group.status }
        : group;
    });
    setOpenGroup(clickValue);
  };

  const CustomListItem = ({ to, primary, icon }) => {
    return (
      <MenuList disablePadding>
        <ListItem
          sx={{ paddingY: 1, marginY: 0 }}
          component={NavLink}
          // to={to}
          to={to === "/boq/lbd" ? `/boq/${boqTeam}` : to}
          className={"appBarLink"}
          activeclassname={"active"}
          onClick={toggleDrawer(false)}
        >
          <img
            key={`${icon}`} // Add key prop for better performance
            src={icon}
            style={styles.sideBarIcon}
          />
          <ListItemText
            sx={{ marginX: 3 }}
            primary={primary}
            primaryTypographyProps={{
              fontSize: "14px",
              color: "#FFF",
            }}
          />
        </ListItem>
      </MenuList>
    );
  };
  const { open, onClose } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"), {
    defaultMatches: true,
    noSsr: false,
  });

  const contentSideBar = (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          backgroundColor: "#1D589D",
          justifyContent: "space-between",
        }}
        color="primary"
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Link to="/home">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton>
                  <HomeIcon fontSize="large" sx={{ color: "white" }} />
                </IconButton>
              </Box>
            </Link>
          </Box>
          <Box
            sx={{
              my: 1,
            }}
          ></Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <IconButton onClick={toggleDrawer(true)}>
              <MenuIcon fontSize="large" sx={{ color: "white" }} />
            </IconButton>
          </Box>
        </Box>
        {openDrawer || open ? (
          <>
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  paddingBottom: "10px",
                }}
              >
                <IconButton>
                  <img src={SbSettingIcon} style={styles.sideBarIcon} />
                </IconButton>
              </Box>
            </Box>
          </>
        ) : (
          ""
        )}
      </Box>
    </>
  );

  const DrawerList = (
    <Box
      sx={{ width: 310, backgroundColor: "#1D589D", height: "100%" }}
      role="presentation"
    >
      <Box sx={{ width: 60 }}>
        <Drawer
          anchor="left"
          open
          PaperProps={{
            sx: {
              width: 60,
              border: "none",
            },
          }}
          variant="permanent"
        >
          {contentSideBar}
        </Drawer>
      </Box>
      <Box
        sx={{
          width: 250,
          marginLeft: "60px",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box sx={{ margin: "0px 0px 0px 0px" }}>
              <img
                alt="sideLogo"
                src={Logo}
                style={{
                  display: "flex",
                  width: "80%",
                }}
              />
            </Box>
          </Box>

          <Box>
            {openGroup.map((item, index) => {
              return item.children ? (
                <Box key={index}>
                  <ListItemButton
                    onClick={() => {
                      handleClick(item.title, item.status, index);
                    }}
                  >
                    <ListItemText
                      sx={{ marginX: 1 }}
                      primary={item.title}
                      primaryTypographyProps={{
                        fontSize: "14px",
                        color: "#5C5C5C",
                      }}
                    />
                    {item.status ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>

                  <Collapse in={item.status} unmountOnExit>
                    {item.children.map((subItem, indexSubItem) => {
                      return (
                        <List
                          component="div"
                          disablePadding
                          sx={{ pl: 2 }}
                          key={indexSubItem}
                        >
                          <CustomListItem
                            primary={subItem.title}
                            to={subItem.pathName}
                            icon={subItem.icon}
                          />
                        </List>
                      );
                    })}
                  </Collapse>
                </Box>
              ) : (
                <CustomListItem
                  key={index}
                  primary={t(`home.menu.${item.title}`)}
                  to={item.pathName}
                  icon={item.icon}
                />
              );
            })}
          </Box>
        </Box>
        <Box>
          <List>
            <ListItem
              key="manage"
              disablePadding
              component={NavLink}
              to="/user"
              onClick={toggleDrawer(false)}
            >
              <ListItemButton>
                <ListItemText
                  primary={t("home.menu.setting")}
                  primaryTypographyProps={{
                    fontSize: "14px",
                    color: "#FFF",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Box>
    </Box>
  );

  if (lgUp && !isHome) {
    return (
      <>
        <Drawer
          anchor="left"
          open
          PaperProps={{
            sx: {
              width: 60,
            },
          }}
          variant="permanent"
        >
          {contentSideBar}
        </Drawer>
        <Drawer
          open={openDrawer}
          onClose={() => {
            setOpenDrawer(false);
          }}
        >
          {DrawerList}
        </Drawer>
      </>
    );
  }

  return (
    <Drawer open={open} onClose={onClose}>
      {DrawerList}
    </Drawer>
  );
}

SideBar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
